import { largeScreenQuery } from './largeScreenQuery';

import type { SidebarMode } from './useSidebarMode';

// Whether the nav should be displayed or hidden. Nav is displayed when the sidebar is docked or expanded,
// or if the sidebar is uninitialized on a large screen.
export function isSidebarVisible(sidebarMode: SidebarMode): boolean {
  if (sidebarMode === 'uninitialized') {
    return largeScreenQuery.matches;
  }

  return sidebarMode !== 'collapsed';
}
